import React, {useState} from 'react';

export const ContentOlvContraseña = (props) => {
	const {goToLogin, enviarCorreoCodigo, estadoRecuperarContraseña, consultarCorreo} = props;

	const [correo, setCorreo] = useState('');

	const comprobarCorreo = () =>{
		consultarCorreo(correo)
	}

	return (
		<div className='ContentOlvContraseña'>
			<div className='text-center fw-semibold fs-5'>¿Ha olvidado su contraseña?</div>
			<div className=''>Introduzca su correo electrónico para recuperar la contraseña.</div>
			<div className='inputCorreoOlvidarContraseña'>
				{estadoRecuperarContraseña === 2 && (
					<div className='centrador correroInvalido'>El correo ingresado no existe</div>
				)}
				<label className='fw-bold'>Correo de recuperación:</label>
				<input
					type='email'
					placeholder='Correro electrónico'
					className='text-dark form-control'
					value={correo}
					onChange={(e) => setCorreo(e.target.value)}
				/>
			</div>
			<div className=''>
				<button
					className='btn login-boton w-full'
					onClick={comprobarCorreo}
				>
					<b>Restablecer</b>
				</button>
			</div>
			<div className='centrador'>
				<div className='barraSeparadorContentBodyLoginInterno' />
			</div>
			<div className='centrador linkRestablecerContraseña'>
				<div> o </div>
				<b onClick={goToLogin}> inicia sesión</b>
			</div>
		</div>
	);
};
